import { css } from 'styled-components';

export default css`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;
